<template>
<div class="form-group">
    <textarea
        :value="value"
        :type="type"
        :id="uuid"
        :placeholder="placeholder"
        class="form-control textarea-lg"
        :class="{
            'is-invalid': error,
            'form-control--filled': value
        }"
        :maxlength="maxLength"
        @input="$emit('input', $event.target.value)"
        v-bind="ariaLabel ? { 'aria-label': ariaLabel } : {}"
    ></textarea>
    <label
        v-if="label"
        :for="uuid"
    >
        <slot>Field: {{ uuid }}</slot>
    </label>
    <small class="form-text text-muted" style="text-align: right;" v-if="maxLengthCounter">
        {{ value.length }} / {{ maxLength }} Zeichen
    </small>
    <slot
        v-if="error"
        name="error"
    >
        <div class="invalid-feedback">
            Dieses Feld ist ein Pflichtfeld.
        </div>
    </slot>
</div>

</template>

<script>
import uuid from 'uuid/v1'

export default {
    name: 'TextareaCustom',

    props: {
        ariaLabel: {
            type: String,
            default: null
        },

        type: {
            type: String,
            default: 'text'
        },

        label: {
            type: Boolean,
            default: false
        },

        placeholder: {
            type: String,
            default: ''
        },

        error: {
            type: Boolean,
            default: false
        },

        maxLength: {
            type: Number,
            default: 1000000
        },

        maxLengthCounter: {
            type: Boolean,
            default: false
        },

        value: null
    },

    data () {
        return {
            uuid: uuid()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/elements/TextareaCustom.vue